import React from 'react';
import AppButton from '../AppButton/AppButton';
import PriceViewer from '../../PriceViewer/PriceViewer';
import './BookButton.scss';
import { useTranslation } from 'react-i18next';

type Props = {
   price: number;
   onClick: () => void;
   isLoading?: boolean
   disabled?: boolean
};

const BookButton: React.FC<Props> = ({ price, isLoading, onClick, disabled }) => {
   const [t] = useTranslation();

   return (
      <AppButton onClick={onClick} className={'book-button'} isLoading={isLoading} disabled={disabled}>
         {t('Бронювати за')}
         <PriceViewer price={price} />
      </AppButton>
   );
};

export default BookButton;
